var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"picker",rawName:"v-picker",value:({ value: _vm.value }),expression:"{ value }"}],attrs:{"type":"text"},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }